import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'terms-of-service';
export const ASSET_NAME_2 = 'privacy-policy';

export const loadData = (params, search) => dispatch => {
  const pageAsset = {
    termsOfService: `content/pages/${ASSET_NAME}.json`,
    privacyPolicy: `content/pages/${ASSET_NAME_2}.json`,
  };
  return dispatch(fetchPageAssets(pageAsset, true));
};
